import { render, staticRenderFns } from "./Judgment.vue?vue&type=template&id=aa8e3900&scoped=true"
import script from "./Judgment.vue?vue&type=script&lang=js"
export * from "./Judgment.vue?vue&type=script&lang=js"
import style0 from "./Judgment.vue?vue&type=style&index=0&id=aa8e3900&prod&lang=css"
import style1 from "./Judgment.vue?vue&type=style&index=1&id=aa8e3900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8e3900",
  null
  
)

export default component.exports